import { Tooltip } from "@omni/types/components/general/toolip.model";
import { Translate } from "@omni/types/utils/translate";

import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";

const broadcastAddToCartNotAvailableForServiceProduct = (t: Translate) =>
    broadcastMessage({
        id: "pdp-error",
        text: t("general.message.addToCartNotAvailableForServiceProduct"),
        status: "info",
        dismissible: true
    });

const validateTooltip = (tooltip: Tooltip | undefined): Tooltip | undefined => {
    if (tooltip?.text) {
        return tooltip;
    }

    return undefined;
};

export { broadcastAddToCartNotAvailableForServiceProduct, validateTooltip };
